import request from '@/utils/request'

/**
 * @apiName 服务商列表
 */
export function getPurchaseProviderList(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/provider/list',
    method: 'POST',
    data,
  })
}
